export namespace Theme {
  enum Colors {
    white = '#FFFFFF',
    disabled = '#9c9c9c',
    disabledBg = '#e9e5e3',

    lightGrey = '#E5E5E5',
    grey = '#CECECE',
    darkGrey = '#292929',

    brown = '#453304',
    black = '#151515',
    dark = '#000000',

    red = '#DB0007',
    lightRed = '#EF634B',
    orange = '#FFBC0D',
    yellow = '#FFCD4B',

    green = '#004E31',
    blue = '#D4E3FF',
    darkBlue = '#38448C'
  }

  enum Aliases {
    disabled = Colors.lightGrey,
    text = Colors.darkGrey,
    border = Colors.grey,
    error = Colors.red
  }

  export const color = {
    ...Aliases,
    ...Colors
  };

  export const font = {
    family: {
      roboto: 'Roboto',
      speedee: 'Speedee',
      speedeeCondensed: 'Speedee Condensed'
    },

    style: {
      normal: 'normal',
      italic: 'italic'
    },

    weight: {
      thin: 100,
      light: 300,
      regular: 400,
      medium: 500,
      bold: 700,
      black: 900
    }
  };

  export const rems = (px: number) => `${px * 0.0625}rem`;
}
